<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Rétractation de votre commande</div>
</div>

<div class="row w-100 pt-3">
    @if (customer.company) {
        <div><strong>{{ customer.company }}</strong></div>
    }
    <div><strong>{{ customer.lastName + ' ' + customer.firstName }}</strong></div>
    <div><strong>{{ line.phoneNumber + ' - ' + line.offer.labelTunnel }}</strong></div>
</div>

@if (step == 1) {
    <div class="row w-100 pt-3">
        <!------------------------------------------------- Création de ligne ------------------------------------->
        @if (!isPortability) {
            <div class="col-12 text-center">
                <p>En vous rétractant, votre ligne <span class="bold-red-text">{{ line.phoneNumber }}</span> va être immédiatement résiliée et vous perdrez définitivement ce numéro de téléphone.</p>
                @if (activeLines >= 1) {
                    <p>Une fois la rétractation validée, la carte bancaire utilisée à la souscription va être re-créditée dans les plus brefs délais.</p>
                }
                <p>Je souhaite me rétracter et <strong>résilier définitivement ma ligne <span class="bold-red-text">{{ line.phoneNumber }}</span> chez {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }} ?</strong></p>
            </div>
        } @else {
            @if (!isActiveLine) {
                <!------------------------------- En attente de portabilité, prévue dans plus de 48h -------------------->
                @if (billStartDate > 2) {
                    <div class="col-12 text-center">
                        <p>En vous rétractant, la portabilité de votre ligne <span class="bold-red-text">{{ line.phoneNumber }}</span> chez {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }} va être annulée, cette ligne restera donc chez votre opérateur actuel.</p>
                        @if (activeLines >= 1) {
                            <p>Une fois la rétractation validée, la carte bancaire utilisée à la souscription va être re-créditée dans les plus brefs délais.</p>
                        }
                        <p>Je souhaite me rétracter et <strong>annuler l’activation de ma ligne <span class="bold-red-text">{{ line.phoneNumber }}</span> chez {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }} ?</strong></p>
                    </div>
                } @else {
                    <!------------------------------- En attente de portabilité, prévue dans moins de 48h -------------------->
                    @if (subStep == 0) {
                        <div class="row w-100 pt-3 text-center">
                            <div class="col-12 text-center">
                                <strong>Souhaitez-vous conserver votre numéro de téléphone ?</strong>
                                <div class="radio-options">
                                    <label for="confirmation3">
                                        <input type="radio" id="confirmation3" name="validation" value="true"
                                               (click)="setStep(1, 'subStep')">
                                        Oui
                                    </label>

                                    <label for="confirmation4">
                                        <input type="radio" id="confirmation4" name="validation" value="false"
                                               (click)="setStep(2, 'subStep')">
                                        Non
                                    </label>
                                </div>
                            </div>
                        </div>
                    } @else if (subStep == 1) {
                        <div class="col-12 text-center">
                            <p>Si vous voulez garder votre numéro, <strong>ne vous rétractez pas</strong>. Attendez l'activation de votre ligne chez {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }} prévue le <span class="bold-red-text">{{ formatDate(line.statusDetails.portabilityDate) }}</span>, puis appelez le 3179 (appel gratuit) depuis votre carte SIM {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }} pour obtenir votre RIO. Ensuite, <strong>transmettez-le à votre nouvel opérateur qui se chargera de récupérer votre ligne.</strong></p>
                            @if (activeLines >= 1) {
                                <p>Une fois la rétractation validée, la carte bancaire utilisée à la souscription va être re-créditée dans les plus brefs délais.</p>
                            }
                        </div>
                    } @else {
                        <div class="col-12 text-center">
                            <p>
                                En vous rétractant, votre ligne <span class="bold-red-text">{{ line.phoneNumber }}</span> va être résiliée et vous perdrez définitivement ce numéro de téléphone.
                                <br/>
                                La portabilité de votre numéro étant prévue dans moins de 48 heures, elle ne peut plus être annulée. Votre rétractation prendra donc effet après l'activation de votre ligne chez {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }}.
                            </p>
                            @if (activeLines >= 1) {
                                <p>Une fois la rétractation validée, la carte bancaire utilisée à la souscription va être re-créditée dans les plus brefs délais.</p>
                            }
                            <p>Je souhaite me rétracter et <strong>résilier définitivement ma ligne <span class="bold-red-text">{{ line.phoneNumber }}</span>  chez {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }} ?</strong></p>
                        </div>
                    }
                }
            } @else {
                <!--------------------------------------------------- Ligne déjà portée --------------------------------------->
                @if (subStep == 0) {
                    <div class="row w-100 pt-3 text-center">
                        <div class="col-12 text-center">
                            <strong>Souhaitez-vous conserver votre numéro de téléphone ?</strong>
                            <div class="radio-options">
                                <label for="confirmation1">
                                    <input type="radio" id="confirmation1" name="validation" value="true"
                                           (click)="setStep(1, 'subStep')">
                                    Oui
                                </label>

                                <label for="confirmation2">
                                    <input type="radio" id="confirmation2" name="validation" value="false"
                                           (click)="setStep(2, 'subStep')">
                                    Non
                                </label>
                            </div>
                        </div>
                    </div>
                } @else if (subStep == 1) {
                    <div class="col-12 text-center">
                        <p>
                            Si vous voulez garder votre numéro, <strong>ne vous rétractez pas</strong>. Appelez le 3179 (appel gratuit) depuis votre carte SIM {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }} pour obtenir votre RIO. Ensuite, <strong>transmettez-le à votre nouvel opérateur qui se chargera de récupérer votre ligne.</strong>
                        </p>
                        @if (activeLines >= 1) {
                            <p>Une fois la rétractation validée, la carte bancaire utilisée à la souscription va être re-créditée dans les plus brefs délais.</p>
                        }
                    </div>
                } @else {
                    <div class="col-12 text-center">
                        <p>
                            En vous rétractant, votre ligne <span class="bold-red-text">{{ line.phoneNumber }}</span> va être résiliée et vous perdrez définitivement ce numéro de téléphone.
                        </p>
                        @if (activeLines >= 1) {
                            <p>Une fois la rétractation validée, la carte bancaire utilisée à la souscription va être re-créditée dans les plus brefs délais.</p>
                        }
                        <p>Je souhaite me rétracter et <strong>résilier définitivement ma ligne <span class="bold-red-text">{{ line.phoneNumber }}</span> chez {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }} ?</strong></p>
                    </div>
                }
            }
        }
        <div class="row w-100 text-center">
            <div class="cta_container">
                <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                @if (
                    !isPortability ||
                    (!isActiveLine && billStartDate > 2) ||
                    (!isActiveLine && billStartDate <= 2 && subStep == 2) ||
                    (isActiveLine && subStep == 2)
                ) {
                    <button type="submit" class="cta_btn level_2 column" (click)="setStep(2, 'step')">Continuer<span></span></button>
                }
            </div>
        </div>
        <div class="col-12 mt-2">
            Un e-mail de confirmation sera envoyé à <strong>{{ customer.email }}</strong>. Pour le recevoir sur une autre adresse e-mail, modifiez votre adresse e-mail dans <a routerLink="/compte/infos">Mes Infos</a> avant de valider la demande de rétractation.
        </div>
    </div>
} @else {
    <div class="row w-100 pt-3 text-center">
        <div class="col-12 text-center">
            Je confirme ma demande de rétractation pour la ligne <span class="bold-red-text">{{ line.phoneNumber }}</span>.
            @if (!isPortability || subStep === 2) {
                <br/>
                <span>J’ai bien compris que je perdrai définitivement ce numéro de téléphone.</span>
            }
        </div>
        <div class="cta_container">
            <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
            <button type="submit" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
        </div>
    </div>
}
